var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.15,
    viewBox: "0 0 18 18.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9997",
    "data-name": "Group 9997",
    transform: "translate(-2866 -12969)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5162",
    "data-name": "Rectangle 5162",
    width: 18,
    height: 18,
    transform: "translate(2866 12969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_4369520_chat_comments_communication_forum_icon",
    "data-name": "4369520_chat_comments_communication_forum_icon",
    transform: "translate(2856 12969.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18519",
    "data-name": "Path 18519",
    d: "M11,2.883V12.3a1.879,1.879,0,0,0,1.883,1.883h9.966l2.767,2.767a.417.417,0,0,0,.3.13.521.521,0,0,0,.159-.029.46.46,0,0,0,.275-.406V2.883A1.879,1.879,0,0,0,24.471,1H12.883A1.879,1.879,0,0,0,11,2.883Zm14.485,0V15.6l-2.158-2.158a.394.394,0,0,0-.3-.13H12.883A1.008,1.008,0,0,1,11.869,12.3V2.883a1.008,1.008,0,0,1,1.014-1.014H24.471A1.008,1.008,0,0,1,25.485,2.883Z",
    transform: "translate(0 0)",
    fill: "#919191",
    stroke: "#919191",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18521",
    "data-name": "Path 18521",
    d: "M37.435,36.869h6.953a.435.435,0,1,0,0-.869H37.435a.435.435,0,1,0,0,.869Z",
    transform: "translate(-22.234 -29.93)",
    fill: "#919191",
    stroke: "#919191",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18522",
    "data-name": "Path 18522",
    d: "M37.435,51.869h4.78a.435.435,0,1,0,0-.869h-4.78a.435.435,0,1,0,0,.869Z",
    transform: "translate(-22.234 -42.758)",
    fill: "#919191",
    stroke: "#919191",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 0.454,
    cy: 0.454,
    r: 0.454,
    transform: "translate(21.902 8.268)",
    fill: "#919191",
    stroke: "#919191",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.805fbc8d3edcc3bf51e2c8a3dd0d224f.svg";
export { ForwardRef as ReactComponent };